import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '../auth/AuthContext';
import type { FetchFormResponse } from '../service/types';
import { Query } from '../types';
import { fetchForm } from '../service/form';

export const useFormData = () => {
  const { fetchJWT } = useAuthContext();

  return useQuery<FetchFormResponse, Error>({
    queryKey: [Query.FormData],
    queryFn: async () => {
      const token = (await fetchJWT()).idToken;
      if (!token) {
        console.log('useFormData not authenticated, token:', token);
        throw Error('Not authenticated');
      }

      try {
        const result = await fetchForm(token);

        if (typeof result === 'string' && (result as string).trim() === 'undefined') {
          console.warn('[useFormData] fetchForm returned "undefined" string — falling back to empty answers');
          return { answers: {} };
        }

        return result;
      } catch (err) {
        console.error('[useFormData] fetchForm threw error:', err);
        return { answers: {} };
      }
    },
    staleTime: Number.POSITIVE_INFINITY,
  });
};
